import { render, staticRenderFns } from "./LandTechnicalFeatures.vue?vue&type=template&id=d1f334a2&"
import script from "./LandTechnicalFeatures.vue?vue&type=script&lang=ts&"
export * from "./LandTechnicalFeatures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports